/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import attorneySectionHeadingsStyle from "./attorneySectionHeadingsStyle";
import Typography from "@mui/material/Typography";

type AttorneySectionHeadingsProps = {
  heading?: string;
  subheading?: string;
};
const AttorneySectionHeadings = ({
  heading = "Deutschlandweit tätige Anwälte",
  subheading = "Sie möchten sich professionell und unkompliziert scheiden lassen? Dann können Sie hier direkt loslegen - jederzeit und ortsunabhängig!",
}: AttorneySectionHeadingsProps) => {
  return (
    <div>
      <Typography variant={"h2"} sx={attorneySectionHeadingsStyle.header}>
        {heading}
      </Typography>
      <Typography variant={"h4"} sx={attorneySectionHeadingsStyle.header}>
        {subheading}
      </Typography>
    </div>
  );
};

export default AttorneySectionHeadings;
